<template>
    <div v-if="entrega && (entrega.status == 6 || entrega.status == 7)">
        <app-k-v
            titulo="Dt Prevista do Início"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="$moment(entrega.dataPrevistaInicio).format('DD/MM/YYYY')"
        ></app-k-v>
        <app-k-v
            titulo="Dt Comun. Cancel."
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="
                $moment(entrega.dataComunicacaoCancelamento).format(
                    'DD/MM/YYYY'
                )
            "
        ></app-k-v>
        <!-- <app-k-v titulo="Valor Cancel." :md="md" :lg="lg" :xl="xl"
            ><strong>{{
                entrega.valorCancelamento | currency
            }}</strong></app-k-v
        > -->
        <app-k-v titulo="Motivo" :md="md" :lg="lg" :xl="xl">
            <strong> {{ entrega.tipoCancelamento }}</strong></app-k-v
        >
        <app-k-v titulo="Classificação" :md="md" :lg="lg" :xl="xl">
            <strong> {{ entrega.subTipoCancelamento }}</strong></app-k-v
        >
        <app-k-v titulo="Just. do Cancel." :md="md" :lg="lg" :xl="xl">
            <strong> {{ entrega.justificativaCancelamento }}</strong></app-k-v
        >
    </div>
</template>

<script>
export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            xl: 2,
            lg: 3,
            md: 3
        }
    }
}
</script>
